import { HIDDEN_OUTPUT_NOTICE } from '../../session/testResults'

// The terminal note in study conditions (TerminalContext) after the harness's line that output
// printed while the hidden tests ran is not shown: during Run Tests the hidden tests call the
// student's methods with their output captured - showing it could reveal the tests' inputs - so
// a print() inside a method stays silent unless the student's own code calls that method. E1
// students saw only the harness's line; one asked why their prints never appeared.
export const PRINT_NOTE = "To see what a print() inside a method shows, call that method yourself at the bottom of your file."

// Whether one piece of the run's output is the harness's line about hidden output.
export const isHiddenOutputNotice = (output) => typeof output === 'string' && output.includes(HIDDEN_OUTPUT_NOTICE)
